/**
 * Main Dashboard Component with Real-Time Updates
 */

import { useEffect, useState } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { LiveOpportunityFeed } from './LiveOpportunityFeed';

export function Dashboard() {
  const { messages } = useWebSocket();
  const [opportunities, setOpportunities] = useState<any[]>([]);
  
  // Handle real-time updates from WebSocket
  useEffect(() => {
    messages.forEach(msg => {
      if (msg.type === 'opportunity') {
        setOpportunities(prev => [msg.data, ...prev]);
      }
    });
  }, [messages]);
  
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-2xl font-bold mb-4">Dashboard</h2>
        <p className="text-gray-600 mb-4">
          Welcome to your AI-powered stock research platform. Monitor opportunities, analyze stocks, and make informed decisions.
        </p>
      </div>
      
      <LiveOpportunityFeed 
        opportunities={opportunities} 
        realtime={false}
      />
    </div>
  );
}

